import { useEffect, useState } from 'react';
import { PhoneStep } from './phoneStep';
import { SmsStep } from './smsStep';
import { ProfileStep } from './profileStep';
import { Already } from 'components/finish/already.js';
import { Finish } from 'components/finish/finish.js';
import { Bug } from 'components/finish/bug.js';


export const Login = ({ closed, setStep: setStepParent }) => {
	const [step, setStep] = useState(0);
	const [phone, setPhone] = useState('');
	const [isNew, setIsnew] = useState(false);
	const [expiredIn, setExpiredIn] = useState(5);
	const [smsError, setSmsError] = useState(false);
	const [user, setUser] = useState(null);
	const [token, setToken] = useState(null);
	const [pollComplete, setPollComplete] = useState(false);
  	const [error, setError] = useState(null)
	
	useEffect(()=> {
		setStepParent(step)
	}, [setStepParent, step])

	const nextStep = () => {
		setStep(step + 1);
	};


	switch (step) {
		case 0:
			return (
				<PhoneStep
					nextStep={nextStep}
					setIsnew={setIsnew}
					setPhone={setPhone}
					setStep={setStep}
					setPollComplete={setPollComplete}
					setSmsError={setSmsError}
					setExpiredIn={setExpiredIn}
				/>
			);
		case 1:
			return (
				<SmsStep
					phone={phone}
					isNew={isNew}
					smsError={smsError}
					expired={Math.round((300 - expiredIn) / 60)}
					setStep={setStep}
					setUser={setUser}
					pollComplete={pollComplete}
					setExpired={setExpiredIn}
					nextStep={nextStep}
					setToken={setToken}
				/>
			);
		case 2:
			return <ProfileStep error={setError} phone={phone} setStep={setStep} token={token} user={user} />;
		case 3:
			return <Already  closed={closed} />;
      case 4:
        return <Finish  closed={closed} />;
        case 5:
          return <Bug closed={closed} error={error} />;
		default:
	}
};
